import type { AxiosResponse } from 'axios';
import { cloneDeep } from 'lodash-es';
import { getExportHeaders } from '@/pages/admin/bets/BetsPageHeaders';
import { betService } from '@/services/betService';
import type { IListParams } from '@/types';
import type { IBetFilters } from '@/types';

export function prepareBetExportFilters(filters: Partial<IBetFilters>): Partial<IBetFilters> {
    const filtersCopy = cloneDeep(filters);

    if (filtersCopy.betSearch?.value || filtersCopy.betCustomEventId?.value) {
        if (filtersCopy.betDate) {
            filtersCopy.betDate = { ...filtersCopy.betDate, value: null };
        }
    }

    return filtersCopy;
}

export function buildBetExportParams(filters: Partial<IBetFilters>): IListParams {
    return {
        filters,
        options: {
            page: 1,
            itemsPerPage: 500,
            sortBy: [{ key: 'createdAt', order: 'desc' }],
        },
        requiredData: [],
        requiredDictionaries: [],
        columns: JSON.stringify(getExportHeaders()),
    };
}

export function downloadExportFile(response: AxiosResponse<Blob>, defaultFilename: string): void {
    let filename = defaultFilename;
    const contentDisposition = response.headers['content-disposition'];

    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch?.[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '');
        }
    }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

export async function runBetExport(filters: Partial<IBetFilters>, defaultFilename = 'bets.xlsx'): Promise<void> {
    const params = buildBetExportParams(prepareBetExportFilters(filters));
    const response = await betService.export(params);
    downloadExportFile(response, defaultFilename);
}
